import { render, staticRenderFns } from "./LoyaltyProgramsTable.vue?vue&type=template&id=bf7d7202"
import script from "./LoyaltyProgramsTable.vue?vue&type=script&lang=ts"
export * from "./LoyaltyProgramsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports